import { CaseStudyDetailTemplate } from '@templates'
import { ISSRPageData } from '@interfaces'
import { ResearchAreaService } from '@services'

const CaseStudyDetailEN = ({ global, pageData }: ISSRPageData) => {
  return <CaseStudyDetailTemplate global={global} pageData={pageData} />
}

export default CaseStudyDetailEN

type SSRProps = {
  query: {
    caseStudyId: string
  }
}

export async function getServerSideProps({ query }: SSRProps) {
  const { caseStudyId } = query

  if (!caseStudyId) {
    return {
      notFound: true,
    }
  }

  const pageData = await ResearchAreaService.getCaseStudyPageData(
    'en',
    caseStudyId
  )

  return {
    props: {
      pageData,
    },
  }
}
